var map = {
	"./Airbrake/Description.md": 3929,
	"./Airtable/Description.md": 12022,
	"./Asana/Description.md": 54208,
	"./Assembla/Description.md": 47622,
	"./Axosoft/Description.md": 53180,
	"./AzureDevOps/Description.md": 59752,
	"./Backlog/Description.md": 86357,
	"./Bitbucket/Description.md": 20411,
	"./Breeze/Description.md": 55405,
	"./Bugasura/Description.md": 63990,
	"./Bugherd/Description.md": 75329,
	"./Bugsnag/Description.md": 36817,
	"./Bugzilla/Description.md": 46708,
	"./Clickup/Description.md": 35259,
	"./Datadog/Description.md": 26680,
	"./DevRev/Description.md": 91506,
	"./Favro/Description.md": 72660,
	"./Flock/Description.md": 71087,
	"./FogBugz/Description.md": 24730,
	"./Github/Description.md": 81153,
	"./GithubCopilotChat/Description.md": 27657,
	"./Gitlab/Description.md": 50369,
	"./GoodDay/Description.md": 6187,
	"./GoogleChat/Description.md": 23267,
	"./Hive/Description.md": 33844,
	"./Jira/Description.md": 71282,
	"./LinearApp/Description.md": 98114,
	"./Mantis/Description.md": 62334,
	"./Mattermost/Description.md": 37320,
	"./MicrosoftTeams/Description.md": 30184,
	"./Miro/Description.md": 93827,
	"./Monday/Description.md": 44694,
	"./NewRelic/Description.md": 73075,
	"./Notion/Description.md": 48447,
	"./PagerDuty/Description.md": 58189,
	"./Paymo/Description.md": 93684,
	"./PivotalTracker/Description.md": 2849,
	"./Practitest/Description.md": 11675,
	"./Redmine/Description.md": 66398,
	"./RocketChat/Description.md": 31564,
	"./Shopify/Description.md": 24368,
	"./Shortcut/Description.md": 90620,
	"./Slack/Description.md": 61390,
	"./SpiraTeam/Description.md": 50668,
	"./SumoLogic/Description.md": 95660,
	"./TargetProcess/Description.md": 77272,
	"./Teamwork/Description.md": 88098,
	"./Trello/Description.md": 65792,
	"./Userback/Description.md": 21318,
	"./Webex/Description.md": 94033,
	"./Webhooks/Description.md": 73416,
	"./Wrike/Description.md": 74142,
	"./YouTrack/Description.md": 1164,
	"./Zenkit/Description.md": 11213,
	"./Zipboard/Description.md": 35483,
	"./ZohoBugTracker/Description.md": 12446,
	"./ZohoCliq/Description.md": 79145
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42857;